<script setup>
import {computed, ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()

const linkedinUrl = ref('')

const submit = async () => {
    if (! urlValidates) {
        return;
    }

    const res = await axios.post(route('crm.leads.addLinkedin') ,{
        url: linkedinUrl.value,
    })

    if (res.data.success) {
        notificationStore.addNotification({
            type: 'success',
            title: _mft('crm:addFromLinkedin.processingAvailableShortly.title'),
            message: _mft('crm:addFromLinkedin.processingAvailableShortly'),
            dismissAfter: 5000,
        })
    } else {
        notificationStore.addNotification({
            type: 'error',
            title: _mft('error:error.generalOccurred'),
            message: res.data.error,
            dismissAfter: 5000,
        })
    }
}

const urlValidates = computed(() => {
    if (linkedinUrl.value.length === 0) {
        return false
    }

    const urlPattern = /^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/i;
    return urlPattern.test(linkedinUrl.value);
})

</script>
<template>
    <div>
        <input-text
            label="LinkedIn URL"
            v-model:content="linkedinUrl"
            type="text"
            maxlength="255"
            required
            name="url"
        />

        <div class="flex justify-end">
            <button-success
                type="submit"
                @click="submit"
                :disabled="! urlValidates"
            >
                {{ _mft('crm:create.add') }}
            </button-success>
        </div>
    </div>
</template>
